import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Send, Users, Heart } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Send size={32} data-id="element-124" />,
    title: '加入频道 Join Channel',
    desc: '通过Telegram加入芽笼777官方频道，获取最新伴游资讯和独家优惠'
  }, {
    icon: <Users size={32} data-id="element-125" />,
    title: '浏览选择 Browse & Select',
    desc: '浏览我们精心筛选的伴游档案，选择心仪的伴游对象'
  }, {
    icon: <Heart size={32} data-id="element-126" />,
    title: '预约体验 Book & Enjoy',
    desc: '通过平台安全预约，享受专属的优质伴游服务'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-[#0d0d14]" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <motion.div className="text-center mb-20" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-129">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-130">
            如何<span className="text-pink-primary neon-glow" data-id="element-131">开始</span>
          </motion.h2>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full" data-id="element-132"></motion.div>
        </motion.div>
        <motion.div className="relative" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-133">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-pink-primary/30 to-transparent -translate-y-1/2 z-0" data-id="element-134"></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-135">
            {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center relative" data-id="element-136">
                <div className="w-24 h-24 rounded-full bg-dark-card border-2 border-pink-primary flex items-center justify-center text-pink-primary mb-6 shadow-[0_0_20px_rgba(233,30,140,0.3)] relative" data-id="element-137">
                  {step.icon}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-pink-primary text-white font-bold flex items-center justify-center text-sm shadow-lg" data-id="element-138">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-139">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-140">{step.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}